import { useState, useEffect } from "react";

export default function useDebounce(
  value: string | number | Object,
  delay: number = 500
) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler: ReturnType<typeof setTimeout> = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
